import { DateTime } from 'luxon';
import { ZONE } from '../enum/ZONE';

/**
 * When the study group is announced: always one week after the cohort's onboarding end
 * date, stated only as the start, middle or end of that month.
 *
 * Backend (assignment mail) and frontend (waiting screen step 1) both read this, so the
 * two can never name a different month — and the day is always derived in the study's
 * own zone rather than wherever the code happens to run.
 */
export type MonthSection = 'start' | 'middle' | 'end';

export const getGroupAssignmentDate = (onboardingEndDate: Date): DateTime =>
  DateTime.fromJSDate(onboardingEndDate, { zone: ZONE }).plus({ weeks: 1 });

export const getMonthSection = (date: DateTime): MonthSection => {
  if (date.day >= 21) {
    return 'end';
  }
  if (date.day >= 11) {
    return 'middle';
  }
  return 'start';
};
